module.exports = __webpack_public_path__ + "img/online-personal-trainer-rafiki.db34be99.svg";